export const SUPER_ADMIN = {
	key: 'superAdmin',
	name: 'Super Admin',
	value: 'super admin',
};
export const DOCTOR = { key: 'doctor', name: 'Doctor', value: 'doctor' };
export const PHARMACIST = {
	key: 'pharmacist',
	name: 'Pharmacist',
	value: 'pharmacist',
};
export const ADMIN = {
	key: 'administrator',
	name: 'Admin',
	value: 'administrator',
};
